import { render, staticRenderFns } from "./SearchProperties.vue?vue&type=template&id=6cbc5552&scoped=true&"
import script from "./SearchProperties.vue?vue&type=script&lang=js&"
export * from "./SearchProperties.vue?vue&type=script&lang=js&"
import style0 from "./SearchProperties.vue?vue&type=style&index=0&id=6cbc5552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc5552",
  null
  
)

export default component.exports